const campaign = {
  campaigns: "Campaigns",
  noCampaignsHeading: "No campaigns created yet",
  campaignOptionText: "Start your campaign by choosing campaign type:",
  campaignOptionType: [
    {
      id: 1,
      label: "E-mail campaign ",
      disabled: false,
      subText: "Most Likely to Receive a Reply",
    },
    {
      id: 2,
      label: "Letter campaign",
      disabled: false,
      subText: "Moderate Chance of a Reply",
    },
    {
      id: 3,
      label: "Email & Letter campaign",
      disabled: false,
      subText: "Least Likely to Receive a Reply",
    },
  ],
  newCampaign: "New Campaign",
  noCollectionsYet: "No Collections yet",
  noCollectionsSubText:
    "To run a campaign you need to save companies to a collection. ",
  goToSearch: "Go to Search",
  startCampaign: "Start Campaign",
  next: "Next",
  saveAndProceed: "Save & Proceed",
  saveAndExit: "Save & Exit",
  exitWithoutSaving: "Exit without saving",
  back: "Back",
  createCampaignSubtext: "Create new campaign template",
  edit: "Edit",
  reviewAndRefine: "Review & Refine",
  selectCollection: "Select Collections for Campaign",
  labelForCompanyNAme:
    "What's the name of your Hold Co, Fund or Acquisition Vehicle?",
  phoneNumber: "Phone Number",
  website: "Your Current Main Website",
  headsUp: "Heads up!",
  mailboxAlertDescription:
    "To prevent your mailbox from being flagged as spam, we limit sending to 30 emails per day per email address.",
  mailboxes: "Mailboxes",
  labelPreferredDomain: "What's your preferred domain identity to send emails?",
  labelPreferredMailboxFirstAndLastName:
    "What's your preferred name identity to setup mailbox?",
  labelPreferredMailboxFirstName: "Preferred First Name",
  labelPreferredMailboxLastName: "Preferred Last Name",
  labelTrialPeriodDomainIdentity: "Your trial period domain identity is",
  websiteDomain: "Enter your preferred domain identity e.g. bizcrunch.co",
  allowedTopLevelDomains: " Allowed top-level domains (TLD):",
  allowedTlds: " .co.uk, .com, .net, .co",
  registerNewDomainHelperText:
    "We will register a new domain for your campaign, from available similar options",
  burnerDomain:
    "We have detected the following burner domains for your outreach:",
  outreachMaiboxesHeading:
    "We have detected the following mailboxes for your outreach:",
  mailboxBurnerDomainHeading:
    "New mailboxes with burner domains help isolate outreach campaigns and manage spam risks effectively",
  repliesToEmail: "Forward email",
  repliesToEmailSubtextTooltip:
    "Replies from your campaigns will be forwarded to email address in your BizCrunch profile.",
  notifiedTo: "Send Notifications To",
  notifiedToTooltip:
    "Communications from your campaigns will be notified to this email address in your BizCrunch profile.",
  campaignSummary: "Campaign summary",
  campaignSummarySubtext: "Flexible pricing that grows with you.",
  aboutCredits: "About credits",
  warmingUp: "Warming Up",
  warmingUpSubtext:
    "It will take few days to warmup your campaign inbox. Campaign will be sent automatically out as soon as it's ready.",
  emailsToSend: "Emails to send",
  creditsBalance: "Credits balance",
  editNameHeader: "Name your campaign",
  cancel: "Cancel",
  save: "Save",
  doYouOwnTheDomain: "Do you own this domain?",
  domainError: "Please enter a valid domain (e.g. bizcrunch.co)",
  discardModalHeader: "Are you sure you want to leave?",
  discradModalSubtext: "Campaign progress will be saved as draft",
  reviewEmail: "Review Email",
  copy: "Copy",
  close: "Close",
  parameters: "Parameters",
  variables: [
    "{{firstName}} ",
    "{{lastName}} ",
    "{{companyName}} ",
    "{{sender.firstName}} ",
    "{{sender.lastName}} ",
    "{{sender.company}} ",
    "{{sender.email}} ",
    "{{sender.website}} ",
    "{{sender.phoneNumber}} ",
  ],
  errorMsgCampaignNameExists:
    "Campaign with this name already exists. Please try another name.",
  trialUserBannerText:
    "You’re in your {{days}}-day free trial, with limited quotas for Collecting companies and Emailing recipients. Unlock your full quota by activating your subscription now.",
  trialUserBannerTextForExpressInterestModal:
    "You’re in your trial period, with limited access to show interest for company listings. Activate your subscription to unlock access.",
  trialUserBannerTextDomainSettings:
    "Want to schedule campaigns from your custom domain, End your trial and activate your subscription now",
  unlockFullQouta: "Unlock Full Quota",
  upgrade: "Upgrade",
  upgradeAccount: "Upgrade Account",
  campaignSuccessBannerHeader: "We have successfully created campaign",
  campaignSuccessBannerSubtext:
    "You can view your newly launched campaign in the campaign list.",
  campaignErrorBannerHeader:
    "We have encountered an error while starting your campaign",
  campaignErrorBannerSubtext:
    "but don't worry, your campaign have been saved as draft.",
  notifyViaEmail: "We will notify via email on the status change",
  toPreventSpam: "To prevent your mailbox from being flagged as spam",
  companiesSelected: "Companies selected",
  totalNoOfRecipents: "Total no. recipients",
  totalNoOfLetterRecipients: "Total no. letter recipients",
  totalNoOfEmailRecipients: "Total no. email recipients",
  quotaUsage: "Quota usage",
  emailQoutaUsage: "Email quota usage",
  letterQoutaUsage: "Letter quota usage",
  emailsPerWorkflow: "Emails per workflow",
  recipient: "Recipient",
  recipients: "Recipients",
  totalEmailSent: "Total E-mails Sent",
  warmingUpCampaign: "Warming Up!",
  warmingUpEmailSubText:
    "It will take few days to warmup your campaign inbox. We will notify you via email of progress",
  warmingUpLetterSubText:
    "We're getting ready to send out your letter campaign via our regular mid-week postal service.",
  warmingUpBothSubText:
    "It'll take a few days to warm-up your  campaign inbox, and to send out your letter via our mid-week postal service.",
  endTrial: "End Trial",
  noOfEmailRecipients: "No. of email recipients",
  noOfLetterRecipients: "No. of letter recipients",
  noOfRecipients: "No. of recipients",
  recipientQuota: "Recipient quota",
  emailRecipientQuota: "Email recipient quota",
  letterRecipientQuota: "Letter recipient quota",
  email: "Email",
  letter: "Letter",
  collectionsSelected: "Collections selected",
  subtextForTrialUserEmailSelection: `Your trial mode currently allows you to send emails to only the first 25 recipients. To activate your subscription now, click on "Unlock Full Quota"`,
  subtextForTrialUserLetterSelection: `Your trial mode currently allows you to send letters to only the first 5 recipients. To activate your subscription now, click on "Unlock Full Quota"`,
  subtextForTrialUserCombinedSelection: `Your trial mode currently allows you to send emails to only the first 25 recipients and letters to only the first 5 recipients. To activate your subscription now, click on "Unlock Full Quota"`,
  domainRegistrationInProgress:
    "The domain and mailbox setup are in progress. You can start Email campaigns once the setup is ready. ",
  domainRegistrationInProgressForEmailCampaign:
    "We're currently setting up your domain and mailbox. You'll be able to launch email campaigns once that's done. Meanwhile, you can launch letter campaigns right away!",
  letterOutreachSubtextSummary:
    "Your letters will be prepared and sent within approximately 5 days. We'll update your campaign status as soon as the letters are on their way.",
  endTrialSucessBannerHeader: "Subscription activated, it’s time to scale!	",
  endTrialSucessBannerSubtext:
    "More collections, more email sends, more insights - let’s grow.",
  promoteSourcePlan: `Need to send a high volume of personalised, professional letters each month? Boost your outreach with 500 letters per month on the Source plan, or buy a 100-letter Bolt-On to increase your quota.`,
  letterSubText: [
    "You can write your letter body here, comprised of 4 paragraphs to fit a single-side A4 template.",
    "First and last paragraph can contain 300 typed characters, plus Parameters.",
    "Second and third paragraph can contain 450 typed characters, plus Parameters.",
    `Allowed special characters: .,!?'"-(){}#@$%&*+=/_:;`,
  ],
  preview: "Preview",
  paragraph: "Paragraph",
  maxCharacterLimit: "/300 characters",
  max450CharacterLimit: " /450 characters",
  letterPreview: "Letter Preview",
  lockedCollectionError:
    "Some of the selected collections are locked and cannot be added to the campaign. Please update your selection.",
  totalLetterSent: "Total Letters Sent",
  quotaIncreasedSucesfully: "Quota increased successfully",
  subscriptionActivated: "Your Subscription has been activated",
  subscriptionActivatedSubtext:
    "Your campaign has been saved as a draft. To finish setting it up, click the draft campaign below.",
  activateYourSubscription: "- activate your subscription",
  noRecipientSelected: "No recipient selected",
  zeroRecipientWarning:
    "Your selection has zero recipient count. Please select collections that have at least one recipient.",
  noMatchingResults: "No matching results found",
  manageRecipients: "Manage Recipients",
  archivedCampaignSubText:
    "This is a archived campaign and cannot be started directly.",
  templateCampaignSubText:
    "This is a template campaign and cannot be started directly.",
  needToSetupDomainAndMailbox:
    "Your admin must set up the domain and mailbox before you can start email campaigns.",
  needToSetupDomainAndMailboxByYourOwn:
    "You need to set up your domain and mailbox before starting email campaigns.",
  company: "Company",
  companies: "Companies",
  activateSubscription: "Activate Subscription",
  saveAsDraft: "Save as Draft",
};

const admin = {
  tabOptions: [
    // { value: "profile", label: "User Profile" },
    // { value: "domains", label: "Burner Domains" },
    { value: "userQuota", label: "User Quota Management" },
    { value: "aiData", label: "AI Data" },
    { value: "scribe", label: "Scribe" },
    { value: "summaries", label: "Business Summaries" },
    { value: "apiKeys", label: "API Keys" },
  ],
  userQuota: "userQuota",
  burnerDomains: "Burner Domains",
  profile: "profile",
  dkim: "DKIM",
  cancel: "Cancel",
  save: "Save",
  enterKey: "Enter Key :",
  enterValue: "Enter value :",
  gotoWorkSpaceText:
    "Go to your google worskpace and copy the key and  the value",
  gotoWorkspace: "Go to Google Workspace",
  userDetails: "User Details",
  name: "Name",
  email: "Email",
  currentSubscription: "Current Subscription",
  userId: "User ID",
  subscriptionStatus: "Subscription Status",
  currentQuotas: "Current Quota status for",
  quotaDetails: "Quota Details",
  additionalQuota: "Additional Quota",
  updateRemainingQuota: "Update Remaining Quota",
  adminQuotaManagement: "Admin Quota Management",
  search: "Search",
  searchSubText: "Search to retrieve a particular record",
  successBannerText: "Quota updated successfully",
  errorBannerText:
    " An error occurred while updating quota. Please try again later.",
  saveChanges: "Save Changes",
  usedQuota: "Used Quota:",
  remainingQuota: "Remaining Quota:",
  totalQuota: "Total Quota:",
  generatedApiKeyName: "Generated API Key Name -",
  apiKeyName: "API Key Name -",
  createNewApiKey: "Create New API Key",
  tokenCreatedSuccessfully: "Token created successfully!",
  failedToCreateToken: "Failed to create token. Please try again later.",
  scopes: "Scopes",
  creating: "Creating ...",
  createApiKey: "Create API Key",
  generatedApiKeyTOken: "Generated API Key Token",
  keepThisTokenSecure: "Keep this token secure.",
  apiKeyToken: "API Key Token",
  loadingTOken: "Loading token...",
  failedToLoadToekn: "Failed to load token. Try again later",
  close: "Close",
  apiKeys: "API Keys",
  manageApiKeys:
    "Manage your API keys for accessing different services programmatically.",
};

const collection = {
  titleCollections: "Collections",
  newCollection: "New Collection",
  collectionName: "Collection Name",
  enterNameofCollection: "Enter new collection name",
  save: "Save",
  cancel: "Cancel",
  downloadCollection: "Download Collection",
  newCampaign: "New Campaign",
  noCollectionsFound: "No collections found.",
  cannotDeleteCollectionInUse:
    "This collection is used in campaign and cannot be deleted.",
  deleteCollection: "Delete collection",
  guidanceBannerSubtext: [
    "Collections can only be deleted if they are selected in a Draft Campaign.  But first, you must de-select them in the Campaign Setup and Save that change.",
    "Collections attached to Campaigns that are Warming, Running, Queued, Paused, or Completed cannot be deleted.",
  ],
  errorCollectionAlreadyExists:
    "Collection name already exists. Please try another.",
  collectionDeletedSuccessfully: "Collection deleted successfully!",
  deleteCollectionError: "Unable to delete Collection",
  collectionLockedForBothCampaign: "Locked for email and letter campaign",
  collectionLockedForEmailCampaign: "Locked for email campaign",
  collectionLockedForLetterCampaign: "Locked for letter campaign",
  labelCreatedByMe: "Created by me",
};

const dealTracker = {
  dealTracker: "Deal Tracker",
  dealTrackerSubtext: "Track your deals here",
  currencies: ["GBP", "USD", "EUR"],
};

const payment = {
  activateYourPlan: "Activate Your Plan",
  subscribeNow: "Subscribe Now",
  pricingPlans: "Pricing plans",
  pricingPlanSubtext1: "Before you continue please select your plan.",
  pricingPlansSubtext2:
    "All plans are annual, with the option to pay monthly or upfront for 12 months.",
  startTrial: "Start Your {{days}} Day Free Trial",
  trialHelpIconTooltip:
    "During your trial period you will have a reduced quota allowance",
  tabOptions: [
    { value: "monthly", label: "Monthly billing" },
    { value: "yearly", label: "Annual billing" },
  ],
  monthly: "monthly",
  annualy: "annualy",
  subscribe: "Subscribe",
  getStarted: "Get Started",
  services: "SERVICES",
  yourCurrentPlan: "Your current plan",
  upgrade: "Upgrade",
  trialEndsIn: "Trial ends in ",
  days: " days",
  description: "Our most popular plan for small teams.",
  managePlan: "Manage Plan",
  increaseQuotaHeading: "Increase your quota with top-up:",
  cancelYourPlan: "Cancel your plan",
  monthlyBilling: "Monthly billing",
  annualBilling: "Annual billing (save > 15%)",
  currentPlan: "Current Plan",
  endTrialNow: "End Trial Now",
  cancelPlan: "Cancel Plan",
  singleTopUp: "Single Top up",
  topUp: "Top up",
  summary: "Summary",
  errorForUpgrading:
    " We have encountered an error while upgrading your plan. Please try again later.",
  errorForEndingTrial:
    "We have encountered an error while ending your trial. Please try again later.",
  errorForCancellingPlan:
    "We have encountered an error while cancelling your plan. Please try again later.",
  errorForDowngradingPlan:
    " We have encountered an error while downgrading your plan. Please try again later.",
  errorTryAgainLater: "Please try again later.",
  exceedMonthlyQuota: "Your selection exceeds your monthly quota limit",
  increaseEmailQuota: "Increase Email Quota",
  increaseLetterQuota: "Increase Letter Quota",
  moveRecipients: "Move Recipients",
  moveRecipientSubtext:
    "You can move remaining recipients to a new collection, ready for your next campaign.",
  welcome: "Welcome",
  unlockFullQuotaNow: "Unlock full quota now",
  areYouSureYouWantToUnlockFullQuota:
    "Are you sure you want to cancel your free trial early?",
  unlockFullQuotaNowSubtext:
    "Your free trial will end instantly, and your subscription will start right away.",
  readyToUnlockFullQuota: "Ready to unlock your full quota?",
  activateYourSubscription: "Activate your subscription",
  activateNow: "Activate Now",
  noKeepTrial: "No, keep trial",
  stayInTrial: "Stay In Trial",
  cancelledOn: "Cancels on",
  downgradesOn: "Downgrades on",
  planCancelled: "PLAN CANCELLED",
  active: "Active",
  unavalible: "Unavailable",
  includes: "Includes ",
  rolloverSubtext: " rolled over from previous month",
  comingSoon: "Coming Soon",
  expiredSubText: "Your subscription ended on",
  areyouSureYouWantToCancel: "Are you sure you want to cancel your plan?",
  cancelSubscriptionModalSubtext:
    "Your subscription will remain active until the end of your billing cycle. Your quotas will be available until that date.",
  cancelSubscription: "Cancel Plan",
  close: "Close",
  getEarlyAccess: "Get Early Access",
  skiptheTrial: "Prefer to skip the trial? Subscribe now",
  watchTheTourHelperText: "Want to see BizCrunch in action before your trial?",
  watchTheTour: "Watch the tour",
  bizcrunchTour: "BizCrunch Tour",
  upgradeHelperText:
    "Please upgrade or use a one-time top-up to continue sending.",
  emailQuota: "Email Quota",
  letterQuota: "Letter Quota",
  total: "Total:",
  available: "Available:",
  required: "Required:",
  createCollectionHelperText:
    "Or you can create a new collection with the available quota and try again",
  exceddedBothQuota: "You’ve exceeded both your email and letter quotas.",
  exceededEmailQuota: "You’ve exceeded your email quota.",
  exceededLetterQuota: "You’ve exceeded your letter quota.",
  logoutTextModal: "Not ready yet? Logout and come back later.",
  promoteUpgradePlan:
    "Ready to start saving collections and sending campaigns again? Select a plan and unlock your quota",
  orgBannerHeading: "Team Management",
  orgBannerSubheading: "Update organization details and manager members",
  view: " View ",
  btnNotifyAccountOwner: "Notify Account Owner",
  wantToSeeBizCrunchInAction:
    "Want to see BizCrunch in action before your trial?",
  bookADemo: "Book A Demo",
};

const account = {
  billing: "Billing",
  resetPassword: "Reset Password",
  logout: "Log out",
};

const domainSettings = {
  headingTrialSubscriptionDomain: "Set Up Your Trial Sender Profile",
  headingActiveSubscriptionDomain: "Set Up Your Professional Mailbox",
  websiteDomain: "Enter your preferred domain identity",
  websiteDomainExample: "e.g. bizcrunch.co",
  allowedTopLevelDomains: "Available extensions (TLDs):",
  allowedTlds: " .co.uk, .com, .net, .co",
  autmaticSetup: "Automatic Setup :",
  automaticSetupSubtext:
    "We will register the new domain and configure the mailbox for you",
  protectYourBrand: "Protect Your Brand:",
  protectYourBrandSubText:
    " Using a dedicated outreach domain protects your primary company email and ensures higher reply rates.",
  registerNewDomainHelperText:
    "We will register a new domain for your campaign, from available similar options",
  labelFirstName: "First Name",
  labelLastName: "Last Name",
  labelNoteForMailbox:
    "Note: These will form your sender address, e.g., name@yournewdomain.com",
  labelEnterYourPreferredDomain:
    " Enter your preferred outreach domain (e.g., useyournewdomain.com):",
  labelSharedDomainForTrial: "Your temporary sending domain used for outreach:",
  labelNotifiedTo: "Where you will receive your campaign replies:",
  notifiedToTooltip:
    "Communications from your campaigns will be replied to this email address in your BizCrunch profile.",
  usingSharedDomainSubtext:
    "We use a shared 'sandbox' domain for trial accounts. Enter your name below to create your temporary sending address.",
  buttonRegisterAndCreate: "Register & Create Mailbox",
  buttonWillDoThisLater: " I'll do this later",
  activateSubscriptionDomainSettingsHeading:
    "Want to send from a business domain of your choice?",
  activateSubscriptionDomainSettingsSubheading:
    "Upgrade to a paid plan to remove trial limitations and send from a custom domain.",
  learnWhyWeDoThis: "Learn why we do this.",
  senderIdentity: "Sender Identity",
  subtextNotifedTo:
    "Note: You can change this from platform settings after you finish setting up your domain and mailbox",
};

const paymentOverDueMember = {
  billng: "Billing",
  manageBillingSubtext: "Manage your billing and payment details.",
  headingPaymentFailed: "Payment Failed",
  paymentFailedSubtext:
    " We encountered an issue processing the most recent payment for this account. As a team member, you don't have permission to update billing details.",
  headingActionRequired: "Action Required",
  subTextActionRequired:
    "Please notify the account owner immediately to resolve this issue and prevent service interruption.",
  btnNotifyAccountOwner: "Notify Account Owner",
};

const platformSettings = {
  titlePlatformSettings: "Platform Settings",
  subHeadingPlatformSettings:
    "Manage your platform configuration and integration settings",
  cardTitleCalendarLink: "Calendar Link",
  cardTitleTriggeredWebhook: "Triggered Webhook",
  cardTitleInteractionWebhook: "Interaction Webhook",
  cardTitleDealWebhook: "Deal Webhook",
  subTextCalendarLink:
    "Enter your Calendly or other booking platform link to include in automatic Campaign follow-up emails",
  labelBookingCalendarUrl: "Booking Calendar URL",
  labelToggleCalendarLink: "Automatically Respond To Campaign Replies?",
  toggleSubText:
    "Send an automated email with your calendar link, inviting a mutual-intro call.",
  warningCalendarUrlNull: "Please Provide Calendar URL to enable this",
  subTextTriggeredWebhook:
    "BizCrunch can integrate with your CRM or Automations, via Webhook calls to your custom URLs",
  labelOnInteractionWebhook: "On Interaction Webhook",
  subTextOnInteractionWebhook:
    " Triggered when a Campaign recipient clicks a link in your drip messages.",
  labelOnDealCreationWebhook: "On Deal Creation Webhook",
  subTextOnDealCreationWebhook:
    "Triggered whan a new deal is created in the deal tracker",
  titleExampleJsonPayload: "</> Example JSON Payload",
  titleCampaignRepliesTo: "Campaign replies to",
  subTextCampaignRepliesTo:
    "Enter your email where you want your campaign replies to be sent",
  labelSendNotificationTo: "Send replies from sellers to",
  titleCustomFields: "Custom Fields",
  subTextCustomFields:
    "Add a Custom Fields to re-use in your Campaign messages",
  btnSaveSettings: "Save Settings",
};

const sellerVerfiedListing = {
  titleSellerverfiedListing: "Seller Verified Listings",
  subTextSellerVerifiedListing:
    "On-market opportunities from engaged sellers, ready to contact",
  listedRecently: "Listed Recently",
  brokered: "Brokered",
  sector: "Sector",
  location: "Location",
  aEBITDA: "aEBITDA",
  aEBITDATooltip:
    "Adjusted Earnings Before Interest, Tax, Depreciation and Amortisation",
  askingPrice: "Asking Price",
  underOffer: "Under Offer",
  project: "Project",
  ndaResentNotification: "Your NDA has been resent, Please check your inbox.",
  ndaIssuedNotification:
    "Thanks for your interest, An NDA has been issued, Please check your inbox.",
  description: "Description",
  adjustedEBITDA: "Adjusted EBITDA",
  revenue: "Revenue",
  viewTeaser: "View Teaser",
  viewTeaserTooltip: "Please view teaser before expressing your interest",
  btnInterestExpressed: "Interest Expressed",
  btnRerequestNda: "Re-request NDA",
  btnExpressInterest: "Express Interest",
};

export const clerkLocalization = {
  organizationProfile: {
    navbar: {
      title: "Team",
      description: "Manage your team settings here.",
    },
    start: {
      profileSection: {
        title: "Team Profile",
      },
    },
    profilePage: {
      dangerSection: {
        leaveOrganization: {
          title: "Leave Team",
        },
      },
    },
  },
  formFieldLabel__organizationSlug: "URL",
};

export const lang = {
  campaign,
  admin,
  collection,
  dealTracker,
  payment,
  account,
  domainSettings,
  paymentOverDueMember,
  platformSettings,
  sellerVerfiedListing,
};

export default lang;
